import $ from "jquery";

export const onElementInserted = (containerId, elementId, callback) => {
    const findMatchedElements = function (mutation) {
        if (mutation.addedNodes.length === 0) {
            return null;
        }

        return $(mutation.addedNodes).find(elementId).addBack(elementId);
    };

    const onMutationsObserved = function (mutations) {
        mutations.forEach(function (mutation) {
            const elements = findMatchedElements(mutation);

            if (elements !== null && elements.length !== 0) {
                callback();
            }
        });
    };

    const observer = new MutationObserver(onMutationsObserved);

    if ($(containerId)[0] !== undefined) {
        observer.observe($(containerId)[0], {childList: true, subtree: true});
    }
};
